module.exports = __webpack_public_path__ + "static/media/sneakerlist_nobg_wt.1dbe3e4e.svg";